import Page from "~/pages/Page";
import CambioPasswordComponent from "~/components/CambioPasswordComponent";
import { initShowHidePassword } from "~/components/ShowHidePassword";


class CambioPassword extends Page {
    protected checkPrivacy = false;
    constructor() {
        super("cambiopassword", "Cambio Password");
    }

    pageStart(): Promise<void> {
        // Inizializza la funzionalità di mostra/nascondi password
        initShowHidePassword();
        const cambioPasswordComponent = new CambioPasswordComponent("#frmCambioPassword");

        return cambioPasswordComponent.activate();
    }

    protected async checkPasswordScaduta(): Promise<void> {
        // qui non controllare
    }

}

export default CambioPassword;

